import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Select, MenuItem } from '@mui/material';

// import FolderModal from '../upload/FolderModal';
// import CreateMongoDB from '../mongodb/CreateMongoDB';
import moment from 'moment';
import LogComponent from '../LogComponent';
import MetaDataComponent from '../MetaDataComponent';
import UploadMongoDB from './UploadMongoDB';

import {
    // Box,
    // Button,
    CardContent,
    Checkbox,
    Grid,
    InputAdornment,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    TextField,
    Toolbar,
    Typography,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack
} from '@mui/material';

import MainCard from 'ui-component/cards/MainCard';
import { visuallyHidden } from '@mui/utils';
import DeleteIcon from '@mui/icons-material/Delete';

import SearchIcon from '@mui/icons-material/Search';

import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';

import {
    deleteProjectDocuments,
    updateProjectDocuments,
    fetchProjectDocuments,
    createProjectTables,
    deleteProjectTables,
    removeProjectDocuments,
    removeProjectTables
} from 'store/slices/project';
import { openSnackbar } from 'store/slices/snackbar';

import StorageIcon from '@mui/icons-material/Storage';
import { GridRowModes, DataGrid, GridActionsCellItem, GridRowEditStopReasons } from '@mui/x-data-grid';

import { randomId } from '@mui/x-data-grid-generator';

import { removeAccents } from 'utils/customized-functions';

import DeleteMongoDB from './DeleteMongoDB';
import DeleteMongoDBData from './DeleteMongoDBData';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
// import { FileManager } from "@cubone/react-file-manager";
// import "@cubone/react-file-manager/dist/style.css";

const options = [
    { label: 'Tất cả thời gian', value: 'all' },
    { label: '7 ngày trước', value: '7' },
    { label: '30 ngày trước', value: '30' },
    { label: '90 ngày trước', value: '90' }
];

const sortOptions = [
    { label: 'Xếp theo mới nhất', value: 'desc' },
    { label: 'Xếp theo cũ nhất', value: 'asc' }
];
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order, orderBy) =>
    order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    // { id: 'id', numeric: true, label: 'STT', align: 'center' },
    { id: 'file_name', numeric: false, label: 'Tài liệu', align: 'left' },
    { id: 'file_type', numeric: false, label: 'Loại tài liệu', align: 'center' },
    { id: 'file_size', numeric: true, label: 'Kích thước', align: 'center' },
    { id: 'labels', numeric: false, label: 'Nhãn', align: 'center' },
    { id: 'created_date', numeric: false, label: 'Thời gian cập nhật', align: 'center' }
];

const EnhancedTableHead = ({ onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, theme, selected }) => {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox" sx={{ pl: 3 }}>
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts'
                        }}
                    />
                </TableCell>
                {numSelected > 0 && (
                    <TableCell padding="none" colSpan={8}>
                        <EnhancedTableToolbar numSelected={selected.length} />
                    </TableCell>
                )}
                {numSelected <= 0 &&
                    headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ minWidth: 150, padding: 0 }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                                sx={{
                                    // fontSize: '0.1rem',
                                    fontWeight: 'bold'
                                }}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
            </TableRow>
        </TableHead>
    );
};

EnhancedTableHead.propTypes = {
    theme: PropTypes.object,
    selected: PropTypes.array,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const EnhancedTableToolbar = ({ numSelected, selected }) => (
    <Toolbar
        sx={{
            p: 0,
            pl: 1,
            pr: 1,
            ...(numSelected > 0 && {
                color: (theme) => theme.palette.secondary.main
            })
        }}
    >
        {numSelected > 0 ? (
            <Typography color="inherit" variant="body1">
                Đã chọn {numSelected}
            </Typography>
        ) : (
            <Typography variant="h6" id="tableTitle">
                Nutrition
            </Typography>
        )}
        <Box sx={{ flexGrow: 1 }} />
        {/* {numSelected > 0 && (
            <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={() => selected.forEach((name) => handleDelete(name))}>
                    <DeleteIcon fontSize="medium" />
                </IconButton>
            </Tooltip>
        )} */}
    </Toolbar>
);

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired
};

const apiHost = process.env.REACT_APP_API_URL;

const TableUploadFile = ({ onClick, folderName, projectSubname, fetchProjectTables, dataMongoDBTable, isSetting }) => {
    const [metaDataOpen, setMetaDataOpen] = useState(false);
    const [logOpen, setLogOpen] = useState(false);
    const handleBack = () => {
        setLogOpen(false);
        setMetaDataOpen(false);
    };
    const [originalRows, setOriginalRows] = useState(dataMongoDBTable);
    const [hideTableUploadFile, setHideTableUploadFile] = useState(false);
    const [open, setOpen] = useState(false);
    const [openFolder, setOpenFolder] = useState(false);
    const [sort, setSort] = useState('desc');
    const [timeRange, setTimeRange] = useState('all');
    const theme = useTheme();
    // const dispatch = () => { };
    const dispatch = useDispatch();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('file_type');
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [search, setSearch] = useState('');
    const [rows, setRows] = useState(dataMongoDBTable);
    const [success, setSuccess] = useState(false);
    const [fileName, setFileName] = useState('');
    const [uploadModalState, setUploadModalState] = React.useState('INACTIVE');
    const [folderModalState, setFolderModalState] = React.useState('INACTIVE');
    const [tableCreateModalState, setTableCreateModalState] = React.useState('INACTIVE');
    const [pathFolder, setPathFolder] = React.useState(folderName);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [openDeleteDataModal, setOpenDeleteDataModal] = React.useState(false);
    const [tableName, setTableName] = React.useState('');
    const [tableDesc, setTableDesc] = React.useState('');
    const [deleteId, setDeleteId] = React.useState('');

    // const [dataMongoDB, setDataMongoDB] = React.useState([])
    const [documentRows, setDocumentRows] = React.useState([]);
    // const [documentColumns, setDocumentColumns] = React.useState([])
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [isOpenCreateTable, setOpenCreateTable] = React.useState(false);
    const [isNameTableExists, setNameTableExists] = React.useState(false);

    const projectsState = useSelector((state) => state.project);

    useEffect(() => {
        setRows(projectsState.tables);
        setDocumentRows(projectsState.documents?.rows);
    }, [projectsState]);

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id) => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => {
        dispatch(
            openSnackbar({
                open: true,
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                message: 'Chỉnh sửa thành công',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            })
        );
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };

    const handleDeleteClick = (id) => {
        setOpenDeleteDataModal(true);
        setDeleteId(id);
    };

    const handleDeleteData = (id) => {
        dispatch(deleteProjectDocuments(folderName, tableName, id));
        dispatch(
            openSnackbar({
                open: true,
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                message: 'Xóa thành công',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            })
        );
        setDocumentRows(documentRows?.filter((row) => row.id !== id));
        setOpenDeleteDataModal(false);
        setDeleteId('');
    };

    const handleCancelClick = (id) => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true }
        });

        const editedRow = documentRows?.find((row) => row.id === id);
        if (editedRow.isNew) {
            setDocumentRows(documentRows?.filter((row) => row.id !== id));
        }
    };

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        dispatch(updateProjectDocuments(folderName, tableName, updatedRow));
        dispatch(
            openSnackbar({
                open: true,
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                message: 'Chỉnh sửa thành công',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            })
        );
        setDocumentRows(documentRows?.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const handleCreateTable = async () => {
        if (tableName === '') {
            alert('Vui lòng điền tên bảng');
        } else {
            // setButtonCreateProjectDisabled(true);
            setOpenCreateTable(false);
            await new Promise(async (resolve) => {
                console.log('Success'); // successful response
                dispatch(createProjectTables(folderName.replace('/', ''), removeAccents(tableName), tableDesc));
            }).then((result) => {
                console.log(result);
                dispatch(
                    openSnackbar({
                        open: true,
                        anchorOrigin: { vertical: 'top', horizontal: 'center' },
                        message: 'Một dự án đã được thêm mới',
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        }
                    })
                );
                // setButtonCreateProjectDisabled(false);
                setTableName('');
            });
        }
    };

    const filterDataByTimeRange = (range) => {
        console.log(range);
        const currentDate = moment();
        let targetDate;

        switch (range) {
            case '7':
                targetDate = currentDate.clone().subtract(7, 'days');
                break;
            case '30':
                targetDate = currentDate.clone().subtract(30, 'days');
                break;
            case '90':
                targetDate = currentDate.clone().subtract(90, 'days');
                break;
            case 'all':
                return originalRows;
            default:
                return [];
        }

        return originalRows.filter((row) => {
            const rowDate = moment(row.created_date, 'DD/MM/YYYY HH:mm:ss', true);
            return rowDate.isValid() && (rowDate.isAfter(targetDate) || rowDate.isSame(targetDate));
        });
    };

    const handleOpenMetaData = (row) => {
        setFileName(row.file_name);
        setMetaDataOpen(true);
        setHideTableUploadFile(!hideTableUploadFile);
    };

    const handleFilter = () => {
        if (timeRange === 'all') {
            setRows(originalRows);
        } else {
            const filteredRows = filterDataByTimeRange(timeRange);
            setRows(filteredRows);
        }
    };

    useEffect(() => {
        handleFilter();
    }, [timeRange, originalRows]);

    const handleTimeRangeChange = (e) => {
        setTimeRange(e.target.value);
        setRows(originalRows);
    };

    const handleDelete = () => {
        // console.log(selected)
        dispatch(deleteProjectTables(folderName, tableName));

        setOpenDeleteModal(false);
        setHideTableUploadFile(false);
        dispatch(removeProjectTables());
    };
    const handleSearch = (event) => {
        const newString = event?.target.value;
        setSearch(newString || '');

        if (newString) {
            const newRows = rows.filter((row) => {
                let matches = true;

                const properties = ['file_name', 'file_type', 'file_size', 'labels', 'created_date'];
                let containsQuery = false;

                properties.forEach((property) => {
                    if (row[property]?.toString().toLowerCase().includes(newString.toString().toLowerCase())) {
                        containsQuery = true;
                    }
                });

                if (!containsQuery) {
                    matches = false;
                }
                return matches;
            });
            setRows(newRows);
        } else {
            setOriginalRows(rows);
        }
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleClick = () => {
        const id = randomId();
        let columns = {
            id,
            isNew: true
        };
        projectsState.documents?.columns?.split('|')?.map((data, index) => {
            if (data !== 'id' && data !== '_id' && data !== 'isNew') {
                columns[data] = '';
            }
        });
        setDocumentRows((oldRows) => [columns, ...oldRows]);

        setRowModesModel((oldModel) => ({
            ...oldModel,
            [id]: { mode: GridRowModes.Edit, fieldToFocus: 'id' }
        }));
    };
    // const EditToolbar = (props) => {
    //     const { documentRows, setDocumentRows, setRowModesModel } = props;
    //     // let rows = documentRows
    //     // rows['isNew'] = true
    //     // console.log(rows)
    //     const handleClick = () => {
    //         console.log(documentRows)
    //         setDocumentRows((oldRows) => [
    //             ...oldRows,
    //             documentRows,
    //         ]);

    //         setRowModesModel((oldModel) => ({
    //             ...oldModel,
    //             [id]: { mode: GridRowModes.Edit, fieldToFocus: 'id' },
    //         }));
    //     };

    //     return (
    //         <GridToolbarContainer>
    //             <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
    //                 Add record
    //             </Button>
    //         </GridToolbarContainer>
    //     );
    // }

    let documentColumns = [
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main'
                            }}
                            onClick={() => {
                                handleSaveClick(id);
                            }}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={() => {
                                handleCancelClick(id);
                            }}
                            color="inherit"
                        />
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => {
                            handleEditClick(id);
                        }}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={() => {
                            handleDeleteClick(id);
                        }}
                        color="inherit"
                    />
                ];
            }
        }
    ];

    let arr = projectsState.documents?.columns?.split('|');

    arr?.map((data, index) => {
        if (data !== 'id' && data !== '_id') {
            documentColumns.push({
                field: data,
                headerName: data,
                width: 180,
                editable: true
            });
        } else {
            documentColumns.push({
                field: data,
                headerName: data,
                width: 180
            });
        }
    });

    return (
        <>
            {isSetting === false && (
                <>
                    {!hideTableUploadFile && (
                        <>
                            <MainCard title={`Bảng trong Dự án ${projectSubname}`} content={false}>
                                <div>
                                    <CardContent>
                                        <Grid container sx={{ justifyContent: 'flex-end' }}>
                                            <Grid item lg={1}>
                                                <Button
                                                    variant="contained"
                                                    color="warning"
                                                    onClick={() => {
                                                        onClick();
                                                    }}
                                                >
                                                    Trở về
                                                </Button>
                                            </Grid>
                                            <Grid item lg={1}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => {
                                                        setOpenCreateTable(true);
                                                        // console.log(FolderName);
                                                    }}
                                                >
                                                    Tạo Bảng
                                                </Button>
                                            </Grid>
                                            <Grid item lg={10} sx={{ textAlign: 'right' }}>
                                                <Select
                                                    size="small"
                                                    value={timeRange}
                                                    onChange={handleTimeRangeChange}
                                                    sx={{ marginRight: '10px' }}
                                                >
                                                    {options.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>

                                                <Select
                                                    size="small"
                                                    value={sort}
                                                    onChange={(e) => {
                                                        setSort(e.target.value);
                                                        handleRequestSort(null, 'created_date');
                                                    }}
                                                    sx={{ marginRight: '10px' }}
                                                >
                                                    {sortOptions.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <TextField
                                                    size="small"
                                                    sx={{ width: '200px', marginRight: '0' }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchIcon fontSize="small" />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    onChange={handleSearch}
                                                    placeholder="Tìm kiếm"
                                                    value={search}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <List component="nav" sx={{ width: '800px', margin: '15px' }} aria-label="main mailbox folders">
                                        {rows?.map((data, index) => {
                                            return (
                                                <ListItemButton
                                                    key={index}
                                                    sx={{ borderRadius: `8px`, mt: 0.625, boxShadow: 3 }}
                                                    onClick={() => {
                                                        setHideTableUploadFile(true);
                                                        setTableName(data.table_name);
                                                        dispatch(fetchProjectDocuments(folderName.replace('/', ''), data.table_name));
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <StorageIcon sx={{ fontSize: '1.3rem' }} />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Typography
                                                                variant="body1"
                                                                style={{ color: 'green', fontWeight: '400', fontSize: '24px' }}
                                                            >
                                                                {data.table_name}
                                                            </Typography>
                                                        }
                                                        secondary={
                                                            <Typography variant="body2" style={{ color: 'black' }}>
                                                                Số lượng bản ghi: {data.document_count}
                                                            </Typography>
                                                        }
                                                    />
                                                </ListItemButton>
                                            );
                                        })}
                                    </List>
                                    {/* <SimpleModal open={open} closeModal={() => setOpen(false)} /> */}
                                </div>
                            </MainCard>
                            <Dialog
                                open={isOpenCreateTable}
                                fullWidth
                                onClose={() => {
                                    setOpenCreateTable(false);
                                }}
                                aria-labelledby="form-dialog-title"
                            >
                                {isOpenCreateTable && (
                                    <>
                                        <DialogTitle id="form-dialog-title">Tạo mới dự án</DialogTitle>
                                        <DialogContent>
                                            <Stack spacing={3}>
                                                <DialogContentText>
                                                    {/* <Typography variant="body2" component="span">
                                        Tạo mới dự án với thao tác đơn giản
                                    </Typography> */}
                                                </DialogContentText>
                                                <TextField
                                                    error={isNameTableExists}
                                                    onChange={(e) => {
                                                        setNameTableExists(
                                                            rows.some(
                                                                (object) =>
                                                                    object.table_name.trim().toLowerCase() ===
                                                                    removeAccents(e.target.value.trim().toLowerCase())
                                                            )
                                                        );
                                                        setTableName(e.target.value);
                                                    }}
                                                    autoFocus
                                                    size="small"
                                                    id="tableName"
                                                    name="tableName"
                                                    label="Tên dự án"
                                                    fullWidth
                                                    required
                                                    helperText={isNameTableExists ? 'Tên dự án đã tồn tại, vui lòng nhập tên khác.' : null}
                                                />
                                                <TextField
                                                    onChange={(e) => {
                                                        setTableDesc(e.target.value);
                                                    }}
                                                    size="small"
                                                    id="tableDesc"
                                                    name="tableDesc"
                                                    label="Mô tả dự án"
                                                    fullWidth
                                                />
                                            </Stack>
                                        </DialogContent>
                                        <DialogActions sx={{ pr: 2.5 }}>
                                            <Button
                                                variant="outlined"
                                                // sx={{ color: theme.palette.error.dark, padding: '6px 16px' }}
                                                onClick={() => {
                                                    setOpenCreateTable(false);
                                                    setNameTableExists(false);
                                                    setTableName('');
                                                }}
                                                size="small"
                                                color="secondary"
                                            >
                                                Thoát
                                            </Button>
                                            <Button
                                                disabled={tableName === '' || isNameTableExists}
                                                variant="contained"
                                                sx={{ backgroundColor: '#156DA2' }}
                                                size="small"
                                                onClick={async () => {
                                                    handleCreateTable();
                                                }}
                                            >
                                                Tạo mới
                                            </Button>
                                        </DialogActions>
                                    </>
                                )}
                            </Dialog>
                            {/* <DeleteModal  open={openDeleteModal} dataDelete={selected} closeModal={() => setOpenDeleteModal(false)} handleConfirm={handleDelete}/> */}
                        </>
                    )}
                    {hideTableUploadFile && (
                        <MainCard
                            title={
                                <Typography variant="body1" style={{ color: 'green', fontWeight: '400', fontSize: '18px' }}>
                                    Bảng: {tableName}
                                </Typography>
                            }
                            content={false}
                        >
                            <div>
                                <CardContent>
                                    <Grid container sx={{ justifyContent: 'flex-end' }}>
                                        <Grid item lg={1}>
                                            <Button
                                                variant="contained"
                                                color="warning"
                                                onClick={() => {
                                                    setHideTableUploadFile(false);
                                                    dispatch(removeProjectDocuments());
                                                    fetchProjectTables();
                                                }}
                                            >
                                                Trở về
                                            </Button>
                                        </Grid>
                                        <Grid item lg={1}>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={() => {
                                                    setOpenDeleteModal(true);
                                                    // console.log(FolderName);
                                                    // dispatch(deleteProjectTables(folderName.replace('/',''),tableName))
                                                }}
                                            >
                                                Xóa Bảng
                                            </Button>
                                        </Grid>
                                        <Grid item lg={1}>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => {
                                                    setUploadModalState('ACTIVE');
                                                    // console.log(FolderName);
                                                }}
                                            >
                                                Import Data
                                            </Button>
                                        </Grid>
                                        <Grid item lg={1}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddIcon />}
                                                onClick={() => {
                                                    handleClick();
                                                    // setUploadModalState('ACTIVE');
                                                    // console.log(FolderName);
                                                }}
                                            >
                                                Add Data
                                            </Button>
                                        </Grid>
                                        <Grid item lg={8} sx={{ textAlign: 'right' }}>
                                            <Select
                                                size="small"
                                                value={timeRange}
                                                onChange={handleTimeRangeChange}
                                                sx={{ marginRight: '10px' }}
                                            >
                                                {options.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>

                                            <Select
                                                size="small"
                                                value={sort}
                                                onChange={(e) => {
                                                    setSort(e.target.value);
                                                    handleRequestSort(null, 'created_date');
                                                }}
                                                sx={{ marginRight: '10px' }}
                                            >
                                                {sortOptions.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            <TextField
                                                size="small"
                                                sx={{ width: '200px', marginRight: '0' }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon fontSize="small" />
                                                        </InputAdornment>
                                                    )
                                                }}
                                                onChange={handleSearch}
                                                placeholder="Tìm kiếm"
                                                value={search}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid>
                                        <Box
                                            sx={{
                                                height: 500,
                                                width: '100%',
                                                '& .actions': {
                                                    color: 'text.secondary'
                                                },
                                                '& .textPrimary': {
                                                    color: 'text.primary'
                                                }
                                            }}
                                        >
                                            {documentRows?.length > 0 && (
                                                <DataGrid
                                                    rows={documentRows}
                                                    columns={documentColumns}
                                                    initialState={{
                                                        columns: {
                                                            columnVisibilityModel: {
                                                                // Hide columns status and traderName, the other columns will remain visible
                                                                id: false,
                                                                _id: false
                                                            }
                                                        }
                                                    }}
                                                    editMode="row"
                                                    rowModesModel={rowModesModel}
                                                    onRowModesModelChange={handleRowModesModelChange}
                                                    onRowEditStop={handleRowEditStop}
                                                    processRowUpdate={processRowUpdate}
                                                    // slots={{ toolbar: EditToolbar }}
                                                    // slotProps={{
                                                    //     toolbar: { documentRows, setDocumentRows, setRowModesModel },
                                                    // }}
                                                />
                                            )}
                                            {(documentRows === undefined || documentRows?.length === 0) && (
                                                <List
                                                    component="nav"
                                                    sx={{ width: '800px', margin: '15px' }}
                                                    aria-label="main mailbox folders"
                                                >
                                                    <ListItemButton
                                                        sx={{ borderRadius: `8px`, mt: 0.625, boxShadow: 3 }}
                                                        onClick={() => {
                                                            // setHideTableUploadFile(true);
                                                            // setTableName(data.table_name)
                                                            // dispatch(fetchProjectDocuments(data.project_name, data.table_name))
                                                        }}
                                                    >
                                                        <ListItemIcon>
                                                            <StorageIcon sx={{ fontSize: '1.3rem' }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <Typography
                                                                    variant="body1"
                                                                    style={{ color: 'green', fontWeight: '400', fontSize: '24px' }}
                                                                >
                                                                    This collection has no data
                                                                </Typography>
                                                            }
                                                            secondary={
                                                                'It only takes a few seconds to import data from a JSON or CSV file.'
                                                            }
                                                        />
                                                    </ListItemButton>
                                                </List>
                                            )}
                                        </Box>
                                    </Grid>
                                </CardContent>
                                <UploadMongoDB
                                    projectName={folderName.replace('/', '')}
                                    projectSubname={projectSubname}
                                    modalState={uploadModalState}
                                    setModalState={setUploadModalState}
                                    tableName={tableName}
                                    // fetchFiles={fetchFiles}
                                    fetchProjectDocuments={() => {
                                        dispatch(fetchProjectDocuments(folderName.replace('/', ''), tableName));
                                    }}
                                ></UploadMongoDB>
                                <DeleteMongoDB
                                    open={openDeleteModal}
                                    tableName={tableName}
                                    closeModal={() => setOpenDeleteModal(false)}
                                    handleConfirm={handleDelete}
                                />
                                <DeleteMongoDBData
                                    open={openDeleteDataModal}
                                    closeModal={() => setOpenDeleteDataModal(false)}
                                    handleConfirm={() => {
                                        handleDeleteData(deleteId);
                                    }}
                                />
                            </div>
                        </MainCard>
                    )}
                </>
            )}

            {logOpen && <LogComponent onBack={handleBack} />}
            {metaDataOpen && <MetaDataComponent onBack={handleBack} folerName={folderName} fileName={fileName} />}
        </>
    );
};

export default TableUploadFile;
